/* eslint-disable import/extensions */
import React, { useMemo } from 'react'

import {
  RadioGroup,
  TextField,
  isValidCIF,
  isValidNIF,
  isValidNIE,
  isValidPassport,
} from '@masfront/common-b2c'
import { FastField, Field, useFormikContext } from 'formik'

import {
  Collapse,
  FormControlLabel,
  Grid,
  Radio,
  Box,
  Typography,
  InputAdornment,
} from '@material-ui/core'

import { Owner } from '~/basket/model/lines/signup.model'
import { Billing } from '~/payments/model/billing.model'

type PaymentOwnerProps = {
  showPaymentOwner: boolean
}
export default function PaymentOwner({ showPaymentOwner }: PaymentOwnerProps) {
  const { values } = useFormikContext<Billing>()

  const docType = useMemo(() => {
    if (isValidNIF(values.paymentOwner.docId)) return 'NIF'
    if (isValidCIF(values.paymentOwner.docId)) return 'CIF'
    if (isValidNIE(values.paymentOwner.docId)) return 'NIE'
    if (isValidPassport(values.paymentOwner.docId)) return 'PASS'
    return ''
  }, [values.paymentOwner.docId])
  return (
    <>
      <Box px="24px">
        <Box mb="12px">
          <Typography variant="subtitle1">NÚMERO DE CUENTA O IBAN</Typography>
        </Box>

        <Field component={RadioGroup} name="paymentOwner.owner" data-hook="paymentOwner">
          <Box mb="12px">
            <FormControlLabel
              key={`paymentOwner-${Owner.SAME}`}
              value={Owner.SAME}
              control={<Radio color="primary" />}
              label={<Typography variant="subtitle2">El titular es el pagador</Typography>}
            />
            <FormControlLabel
              key={`paymentOwner-${Owner.OTHER}`}
              value={Owner.OTHER}
              control={<Radio color="primary" />}
              label={<Typography variant="subtitle2">Otro pagador</Typography>}
            />
          </Box>
        </Field>
      </Box>
      <Collapse in={showPaymentOwner}>
        <Box px="24px" style={{ backgroundColor: '#f2f2f2' }} pt={7} mb={9} mt={2}>
          <Grid container spacing={5}>
            <>
              <Grid xs={3} item>
                <Field
                  component={TextField}
                  name="paymentOwner.docId"
                  label="Documento"
                  variant="outlined"
                  inputProps={{
                    maxLength: 9,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Typography
                          variant="caption"
                          color="textSecondary"
                          data-hook="donorOwner.docType"
                        >
                          {docType}
                        </Typography>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid xs={3} item>
                <FastField
                  component={TextField}
                  name="paymentOwner.name"
                  label="Nombre"
                  variant="outlined"
                />
              </Grid>
              <Grid xs={3} item>
                <FastField
                  component={TextField}
                  name="paymentOwner.firstName"
                  label="Primer Apellido"
                  variant="outlined"
                />
              </Grid>
              <Grid xs={3} item>
                <FastField
                  component={TextField}
                  name="paymentOwner.lastName"
                  label="Segundo Apellido"
                  variant="outlined"
                />
              </Grid>
            </>
          </Grid>
        </Box>
      </Collapse>
    </>
  )
}
